var parsePath = function parsePath(url) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!url) return undefined;
  var re = /^(http|https)/;
  if (re.test(url)) {
    return url;
  }
  return (url == null ? void 0 : url.startsWith('/')) ? "".concat(baseUrl).concat(url) : "".concat(baseUrl, "/").concat(url);
};
export default parsePath;